import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { httpinstance,httpinstancefile } from "../../../axios/api"


export const get_Ftltransport_rates = createAsyncThunk('get_Ftltransport_rates', async (queryParams)=>{
    try{
        const url = `transport-rates${queryParams}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})
export const delete_Ftltransport_rates = createAsyncThunk('delete_Ftltransport_rates', async (id)=>{
    try{
        const url = `transport-rates/${id}`
        const response = await httpinstance.delete(url)
        return response
    }catch (err){
        return err.response
    }
})

const initialState = {
    data:{},
    loading:false,
}

const rate_managementSlice = createSlice({
    name : 'FTL_rate_management',
    initialState,
})
export default rate_managementSlice.reducer